import { Api } from '@shared-providers/api.provider';
import { ICalendarEventQuery } from '@shared-libs/interfaces';
import { Injectable } from '@angular/core';
import { Provider } from '@shared-providers/Provider';
import { LoadingService } from '@shared-services/loading.service';
import { ICalendarEvent } from '@shared-models/calendar-event.model';
import { IDataQuery, ITableData } from '@beego/ngx-table';
import { encodeQueryUrl } from '@shared-libs/helpers';

@Injectable({
	providedIn: 'root',
})
export class CalendarEventProvider extends Provider<ICalendarEvent> {
	protected readonly url: string = '/calendar-events';

	constructor(
		protected readonly api: Api,
		protected readonly loadingService: LoadingService
	) {
		super(loadingService);
	}

	public getAll(query: ICalendarEventQuery): Promise<Array<ICalendarEvent>> {
		return this.process(this.api.get(`${this.url}?query=${JSON.stringify(query)}`)) as Promise<
			Array<ICalendarEvent>
		>;
	}

	public getAndCountAll(_dataQuery: IDataQuery): Promise<ITableData<ICalendarEvent>> {
		return this.process(this.api.get(`${this.url}/list?query=${encodeQueryUrl(_dataQuery)}`)) as Promise<
			ITableData<ICalendarEvent>
		>;
	}

	public getDateOfFirstAvailableBeegoStudent(zipcode: string): Promise<Date | null> {
		return this.process(
			this.api.get(`${this.url}/date-first-beego-student?query=${JSON.stringify({ zipcode })}`, true)
		) as Promise<Date | null>;
	}
}
